import React, { useState } from 'react';
import type { BracketCompetitionProps, CompetitionProps, CompetitionSeasonProps, FocusPositionProps, SquaresCompetitionProps } from '../../types';
import { Icons } from '../../Components';
import { EngageApi } from '../api';
import { useColors } from '../../constants/useColors';
import { Button, Text, TextInput, View } from '../../Components/Themed';

type PrivateCodePromptProps = {
    onFoundCompetition:(c:CompetitionProps) => void,
    onFocusPosition?:(pos:FocusPositionProps) => void,
    onFoundSquaresCompetition:(sc:SquaresCompetitionProps) => void,
    onFoundSeason:(cs:CompetitionSeasonProps) => void,
    onFoundBracket:(b:BracketCompetitionProps) => void,
    onClose:() => void
}

const PrivateCodePrompt = ({ onFoundCompetition, onFoundSquaresCompetition, onFocusPosition, onFoundSeason, onFoundBracket, onClose }:PrivateCodePromptProps) => {
    const [ search, setSearch ] = useState<{
        loading:boolean,
        value: string,
    }>({
        loading:false,
        value: ''
    });
    const [ error, setError ] = useState<string|undefined>();
    const { loading, value } = search;

    const Colors = useColors();

    const handleSearch = async() => {
        setSearch({ ...search, loading:true });
        const result = await EngageApi.getPrivateEngage(value);
        setSearch({ ...search, loading:false });
        if(result.competition){ return onFoundCompetition(result.competition) }
        if(result.competition_season){ return onFoundSeason(result.competition_season) }
        if(result.bracket_competition){ return onFoundBracket(result.bracket_competition) }
        if(result.squares_competition){ return onFoundSquaresCompetition(result.squares_competition) }
        setError('Sorry! We could not find any competitions, squares, brackets with that code.')
    }

    const search_valid = value ? true : false
    return (
        <View float style={{ margin:10 }}>
            <View type='header' style={{ padding:15, flexDirection:'row', alignItems:'center', borderTopRightRadius:8, borderTopLeftRadius:8}}>
                <Icons.SearchIcon color={Colors.text.h1} size={20}/>
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>Find Private Competition!</Text>
                </View>
            </View>
            <View style={{ padding:10 }}>
                <View style={{ borderRadius:8, padding:10 }}>
                    <Text size={18} color={Colors.text.h1} textAlign='center' theme='h1'>Did you receive a private code?</Text>
                    <Text style={{ marginTop:10 }} size={14} color={Colors.text.h1} textAlign='center' weight='regular'>Enter the code in the input section below and press FIND.  If we find the competition / squares / bracket, we will send you to it!</Text>
                    <View type='input' style={{ marginTop:10 }}>
                        <TextInput
                            placeholder='Enter Private Code'
                            style={{ textAlign:'center' }}
                            onFocusPosition={onFocusPosition}
                            onChangeText={(text) => {
                                if(error){ setError(undefined) }
                                setSearch({ ...search, value:text })
                            }}
                        />
                    </View>
                    {error?
                    <View style={{ marginTop:10, padding:10 }}>
                        <Text size={14} color={Colors.text.error} weight='bold' textAlign='center'>{error}</Text>
                    </View>
                    :<></>}
                </View>
            </View>
            <View type='footer' style={{ flexDirection:'row', padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                <Button
                    title='CANCEL'
                    type='close'
                    style={{ marginRight:5 }}
                    onPress={() => onClose()}
                />
                <Button
                    style={{ flex:1, opacity:search_valid&&!loading?1:0.5 }}
                    disabled={loading || !search_valid}
                    loading={loading}
                    type='success'
                    title='FIND'
                    onPress={async() => handleSearch()}
                />
            </View>
        </View>
    )
}

export default PrivateCodePrompt